import React, {useCallback, useRef, useState} from "react";
import './shippingScreen.css';
import ShippingMap, {ShippingMapRef} from "features/shipping/components/map/ShippingMap";
import {ShippingFilter} from "../filters/ShippingFilter";
import {ShippingHeader} from "features/shipping/components/screen/ShippingHeader";
import {SelectedShippings} from "shared/ui/selectedShippings/SelectedShippings";
import {TShippingItem} from "features/shipping/types";
import {getTrackingList} from "shared/lib/fns";

const ShippingMapScreen = () => {
  const mapRef = useRef<ShippingMapRef | null>(null);
  const [selectedTrackingList, setSelectedTrackingList] = useState<string[]>([]);
  
  const handleSelectShippings = useCallback((shippings: TShippingItem[]) => {
    setSelectedTrackingList(getTrackingList(shippings, "tracking_number"))
  }, []);
  
  const handleResetSelection = useCallback(() => {
    setSelectedTrackingList([]);
    if(mapRef.current)
      mapRef.current.resetSelection();
  }, []);
  
  return (<div className={"shipping-screen"}>
    <ShippingHeader />
    <div className={"filter"}>
      <ShippingFilter />
      <SelectedShippings
        trackingList={selectedTrackingList}
        onReset={handleResetSelection}
      />
    </div>
    <ShippingMap
      ref={mapRef}
      onSelectShippings={handleSelectShippings}
    />
  </div>);
};

export default ShippingMapScreen;
